import moment from 'moment-timezone'
import store from '@/store'

export function getDefaultShiftsEndDate() {
  const timeZone = store.state.applicationState.timeZone

  return (timeZone ? moment().tz(timeZone) : moment()).format('YYYY-MM-DD')
}

export function getEffectiveShiftsFilter(filter = {}, hasExplicitEndDate) {
  return {
    ...filter,
    end_date: hasExplicitEndDate ? filter.end_date || undefined : getDefaultShiftsEndDate()
  }
}
